import { pick } from 'lodash'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { apiClient } from '../client'
import { AI_VALUE_ENDPOINTS } from './formValuesConfig'
import { AiValuesData, GenerateDescriptionPayload, GenerateDescriptionResponse } from './types'

export const generateDescription = async ({ id, emphasis, descriptionLang }: GenerateDescriptionPayload): Promise<GenerateDescriptionResponse> => {
    const response = await apiClient(`v1/ai/generate/property-description/${id}`, {
        method: 'POST',
        data: { emphasis },
        headers: {
            locale: descriptionLang,
        },
    })

    return response.data
}

export const fetchAiValues = (fields?: string[], formFilters?: Record<string, string | string[]>) => {
    const endpoints = fields ? pick(AI_VALUE_ENDPOINTS, fields) : AI_VALUE_ENDPOINTS

    return fetchFormValues<AiValuesData>(endpoints, formFilters)
}
